/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

async function triggerKlaviyo(target) {
  event.preventDefault();
  event.stopPropagation();

  const form = target.closest("form");

  const email = form.querySelector('input[type="email"]').value;
  const variant_id = target.dataset.variantId;

  if (!form.reportValidity()) return;

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${variant_id}`
            }
          }
        }
      }
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision": "2024-06-15"
      },
      body: JSON.stringify(payload),
    };

    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${target.dataset.key}`,requestOptions);
      
      form.querySelector(".product__notification__form").style = "display: none;";

      if (!response.ok) {
        form.querySelector(".product__notification__message.product__error-msg").style = "display: block;";
        throw response.statusText + " " + response.status;
      }

      form.querySelector(".product__notification__message").style = "display: block;";
    } catch(e) {
      console.log("Error has occured:", e);
    }
}

class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delElem = new Delegate(this.element);    
  }

  connectedCallback() {
    this.delElem.on("click", '[data-action="clear-filters"]', this.clearFilters.bind(this));
    this.delElem.on("keypress", '[data-action="clear-filters"]', this.clearFilters.bind(this));
  }

  clearFilters() {
    event.preventDefault();
    event.stopPropagation();

    if (event.type === "keypress" && event.key !== "Enter") return;

    const link = event.target.dataset.link;
    window.location = link;
  }
}

customElements.define("collection-filters", CollectionFilters);